/**
 * Punto de entrada principal de la aplicación React
 * Renderiza el componente App en el DOM
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/**
 * Crear el root de React y renderizar la aplicación
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
